import React, { useContext } from 'react';

import { Wrapper } from './styles';
import PageHeader from './components/PageHeader';
import Offers from './components/Offers';
import { InsuranceContext } from '../../context/insuranceContext';

const SecondStep: React.FC<{}> = () => {
  const { 
    insurance, 
    insuranceParameters, 
    setInsuranceParameters,
    setInsurance
  } = useContext(InsuranceContext);  

  return (
    <Wrapper>
      <PageHeader
        insurance={insurance}
        setInsurance={setInsurance}
        insuranceParameters={insuranceParameters}
        setInsuranceParameters={setInsuranceParameters}
      />
      <Offers 
        insurance={insurance}
        insuranceParameters={insuranceParameters} 
        setInsurance={setInsurance}
        setInsuranceParameters={setInsuranceParameters}
      />
    </Wrapper>
  );
};

export default SecondStep;
